export default {
  Pending: 'PENDING',
  Succeeded: 'SUCCEEDED',
  Failed: 'FAILED',
};



// WEBPACK FOOTER //
// ./src/framework/async/async-operation-state.js